import { render, staticRenderFns } from "./SearchInfo.vue?vue&type=template&id=5dff693b&scoped=true&"
import script from "./SearchInfo.vue?vue&type=script&lang=js&"
export * from "./SearchInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchInfo.vue?vue&type=style&index=0&id=5dff693b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff693b",
  null
  
)

export default component.exports